<template>
  <div class="product-info-sheet__contain">
    <p class="sheet-title">{{ productDetailTitle }}</p>
    <p v-if="product.description" class="!wd-mb-0 wd-py-4" v-html="nl2br(product.description)" />
  </div>
</template>

<script lang="ts">
import utils from '@/utils'

export default defineComponent({
  name: 'ProductInfoSheet',
  props: {
    product: { type: Object, default: () => ({}) },
  },
  setup() {
    const { productDetailTitle } = usePlatformProductContext()

    return {
      nl2br: utils.nl2br,
      productDetailTitle,
    }
  },
})
</script>

<style lang="scss" scoped></style>
